var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 9,
    fill: "#F0F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8135 19.4434H33.0726C33.8919 19.4434 34.2924 18.5212 33.7098 17.9917L28.6301 13.2437C28.4562 13.0873 28.2246 13 27.9837 13C27.7429 13 27.5113 13.0873 27.3374 13.2437L22.2759 17.9917C21.6933 18.5212 22.0938 19.4434 22.9131 19.4434H26.1722V36.5569H22.9131C22.0938 36.5569 21.6933 37.4791 22.2759 38.0086L27.3556 42.7566C27.7197 43.0811 28.2842 43.0811 28.6483 42.7566L33.728 38.0086C34.3106 37.4791 33.8919 36.5569 33.0908 36.5569H29.8135V19.4434Z",
    fill: "#8ECAF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/Height.57305d5410ae23b5e3c39441ccb9507a.svg";
export { ForwardRef as ReactComponent };